import { type MutationHookOptions, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import type { UpdateLabelDefinition, UpdateLabelDefinitionInput } from 'types/graphql';
import LabelsApi from './Labels.api';

/** The edit modal's `labelTypes` comes from store state and may be unset; the wire stays what it sends today. */
export type UpdateLabelDefinitionArgs = {
  id: number;
  input: Omit<UpdateLabelDefinitionInput, 'labelTypes'> & Partial<Pick<UpdateLabelDefinitionInput, 'labelTypes'>>;
};

export function useUpdateLabelDefinition(
  options?: MutationHookOptions<UpdateLabelDefinition, UpdateLabelDefinitionArgs>
) {
  const [mutate, { loading, error }] = useMutation<UpdateLabelDefinition, UpdateLabelDefinitionArgs>(
    LabelsApi.UpdateLabelDefinition,
    options
  );
  const update = useCallback((variables: UpdateLabelDefinitionArgs) => mutate({ variables }), [mutate]);
  return { update, loading, error };
}
